import SvgPlay from '@sats-group/icons/24/play';
import Modal from '@sats-group/ui-lib/react/modal';
import Text from '@sats-group/ui-lib/react/text';
import VisuallyButton from '@sats-group/ui-lib/react/visually-button';
import cn from 'classnames';
import React from 'react';
import DynamicImage from '../dynamic-image/dynamic-image';
import YoutubePlayer from '../youtube-player/youtube-player';
import type { VideoCard as Props } from './video-card.types';

/** SPEC: https://www.figma.com/file/dQeQgh6sANMhWBUNtgXQNN/satsweb-components?node-id=2242-23231 */
const VideoCard: React.FunctionComponent<Props> = ({
  image,
  tall,
  title,
  video,
}) => (
  <div className={cn('video-card', { 'video-card--tall': tall })}>
    <button className="video-card__image" popoverTarget={video.id}>
      <DynamicImage {...image} aspectRatio={DynamicImage.aspectRatios.square} />
      <div aria-hidden="true" className="video-card__flourish">
        <VisuallyButton
          elementName="div"
          iconOnly
          leadingIcon={<SvgPlay />}
          size={VisuallyButton.sizes.large}
          text=""
          variant={VisuallyButton.variants.ctaSecondaryWhite}
        />
      </div>
    </button>
    <Text size={Text.sizes.large}>{title}</Text>

    <Modal
      ariaLabel=""
      background="primary"
      closeLabel=""
      id={video.id}
      title={title}
    >
      <YoutubePlayer {...video} />
    </Modal>
  </div>
);

export default VideoCard;
